(function () {
  'use strict';

  var BGC = {
    monthlyPlan: 3258581143,
    plans: [
      { id: 3258548375, name: 'Every 2 weeks' },
      { id: 3258581143, name: 'Every month' },
      { id: 3258613911, name: 'Every 6 weeks' },
      { id: 3258646679, name: 'Every 2 months' }
    ],
    products: [
      { id: 5291622170775, handle: 'bossa-nova', title: 'Bossa Nova', fallback: 'https://cdn.shopify.com/s/files/1/0412/3289/2055/files/bossa_nova.png?v=1696991486' },
      { id: 5294850048151, handle: 'ipanema', title: 'Ipanema', fallback: 'https://cdn.shopify.com/s/files/1/0412/3289/2055/files/ipanema.png?v=1696991509' },
      { id: 5305726140567, handle: 'samba', title: 'Samba', fallback: 'https://cdn.shopify.com/s/files/1/0412/3289/2055/files/samba_4db6ff46-ea3f-4ac2-a39e-efa3c8206474.png?v=1696991524' },
      { id: 7994224836759, handle: 'decaf', title: 'Decaf Tropicália', fallback: 'https://cdn.shopify.com/s/files/1/0412/3289/2055/files/DECAF-ground.png?v=1698209506' }
    ]
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function injectGlobalStyles() {
    if (document.getElementById('bgc-master-2026-styles')) return;
    var style = document.createElement('style');
    style.id = 'bgc-master-2026-styles';
    style.textContent = [
      '.header .icon-account{display:none!important}',
      '.bgc-farmer-jump{display:inline-block!important;margin-left:10px!important;background:#D99B32!important;color:#351814!important;padding:12px 18px!important;text-decoration:none!important;font-weight:700!important;border-radius:3px!important}',
      '.bgc-contact-page~.bgc-contact-page{display:none!important}',
      '.bgc-wholesale-contact-list{list-style:none;margin:22px 0 0;padding:0}',
      '.bgc-wholesale-contact-list li{padding:14px 0;border-top:1px solid #E7E1D8}',
      '.bgc-wholesale-contact-list strong{display:block;color:#351814;font-size:17px}',
      '.bgc-wholesale-contact-list a{color:#A8342F!important;word-break:break-word}',
      '.bgc-all-shops-map{width:100%;min-height:520px;background:#eee}',
      '.bgc-map-note{font-size:12px;color:#5f5349;margin:8px 0 0}',
      '.bgc-subscription-shell{position:relative;overflow:hidden;background:linear-gradient(135deg,#fffdf8 0%,#f7efe1 45%,#eef2df 100%);padding:64px 24px 90px}',
      '.bgc-subscription-shell:before,.bgc-subscription-shell:after{content:"";position:absolute;width:340px;height:340px;border-radius:45% 55% 60% 40%;background:rgba(111,123,50,.09);transform:rotate(24deg);pointer-events:none}',
      '.bgc-subscription-shell:before{left:-170px;top:120px}.bgc-subscription-shell:after{right:-190px;bottom:50px;background:rgba(217,155,50,.10)}',
      '.bgc-subscription-inner{position:relative;z-index:1;max-width:1180px;margin:auto}',
      '.bgc-subscription-intro{text-align:center;max-width:790px;margin:0 auto 38px}',
      '.bgc-subscription-kicker{display:block;color:#A8342F;font-size:12px;font-weight:700;letter-spacing:3px;margin-bottom:8px}',
      '.bgc-subscription-intro h1{color:#6F7B32!important;font-size:44px!important;line-height:1.05;margin:0 0 16px}',
      '.bgc-subscription-intro p{font-size:17px!important;line-height:1.65;color:#351814!important}',
      '.bgc-subscription-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:26px}',
      '.bgc-sub-card{background:rgba(255,255,255,.96);border:1px solid #E7E1D8;box-shadow:0 14px 36px rgba(53,24,20,.10);padding:28px;display:grid;grid-template-columns:190px 1fr;gap:22px;align-items:start}',
      '.bgc-sub-card__image{display:flex;align-items:center;justify-content:center;min-height:290px;background:#faf7f0;padding:16px}',
      '.bgc-sub-card__image img{display:block!important;max-width:100%!important;max-height:300px!important;width:auto!important;height:auto!important;object-fit:contain!important}',
      '.bgc-sub-card h2{color:#6F7B32!important;font-size:30px!important;margin:0 0 10px}',
      '.bgc-sub-card__price{color:#351814;font-weight:700;margin-bottom:15px}',
      '.bgc-sub-card__label{display:block;font-size:12px;font-weight:700;letter-spacing:1px;color:#A8342F;margin:12px 0 6px}',
      '.bgc-sub-card select{width:100%;margin:0 0 13px;padding:10px;border:1px solid #D9C9B8;background:#fff;color:#351814}',
      '.bgc-sub-variants{display:grid;gap:8px}',
      '.bgc-sub-variant{width:100%;border:0!important;border-radius:3px;background:#E59A2F!important;color:#351814!important;padding:12px 10px!important;font-weight:800!important;text-align:left!important;line-height:1.2!important;cursor:pointer}',
      '.bgc-sub-variant:hover{background:#F0B84F!important}',
      '.bgc-sub-variant span{display:block;font-size:11px;font-weight:700;letter-spacing:.5px;margin-top:3px}',
      '.bgc-sub-status{min-height:18px;font-size:12px;margin-top:8px;color:#6F7B32;font-weight:700}',
      '.bgc-cart-sub-toggle{margin:8px 12px 10px 92px;padding:10px;border:1px solid #E7E1D8;background:#fff7eb;font-size:11px;line-height:1.35}',
      '.bgc-cart-sub-toggle strong{display:block;color:#351814;margin-bottom:6px}',
      '.bgc-cart-sub-toggle button{font-size:11px!important;padding:7px 8px!important;margin:2px 3px 2px 0!important;border:1px solid #D99B32!important;background:#fff!important;color:#351814!important}',
      '.bgc-cart-sub-toggle button.is-active{background:#D99B32!important;color:#351814!important}',
      '@media(max-width:850px){.bgc-subscription-grid{grid-template-columns:1fr}.bgc-sub-card{grid-template-columns:160px 1fr}.bgc-all-shops-map{min-height:420px}}',
      '@media(max-width:560px){.bgc-subscription-shell{padding:46px 16px 70px}.bgc-subscription-intro h1{font-size:34px!important}.bgc-sub-card{grid-template-columns:1fr;padding:20px}.bgc-sub-card__image{min-height:240px}.bgc-sub-card__image img{max-height:260px!important}.bgc-farmer-jump{margin:10px 0 0 0!important}.bgc-cart-sub-toggle{margin-left:12px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function dedupeContact() {
    if (location.pathname.indexOf('/pages/contact') === -1 && !document.querySelector('.bgc-contact-page')) return;
    var pages = document.querySelectorAll('.bgc-contact-page');
    for (var i = 1; i < pages.length; i++) pages[i].remove();
    var root = pages[0];
    if (!root) return;
    ['.bgc-contact-hero', '.bgc-contact__info', '.bgc-contact__form'].forEach(function (selector) {
      var nodes = root.querySelectorAll(selector);
      for (var j = 1; j < nodes.length; j++) nodes[j].remove();
    });
  }

  function upgradeWholesale() {
    if (location.pathname !== '/pages/wholesale-register') return;
    var panels = document.querySelectorAll('.bgc-wholesale__inner .bgc-wholesale__panel');
    if (!panels.length) return;
    var first = panels[0];
    if ((first.textContent || '').toUpperCase().indexOf('LOG IN') === -1) return;
    first.innerHTML = '<h2>CONTACT US</h2><p class="bgc-wholesale__intro">Please feel free to reach out to our Brazilian Gold Coffee team. We’d be happy to talk with you about wholesale coffee, café service, partnerships, or other opportunities.</p><ul class="bgc-wholesale-contact-list"><li><strong>Josh Jordan</strong><a href="mailto:Josh@BrazilianGoldCoffee.com">Josh@BrazilianGoldCoffee.com</a></li><li><strong>Joshua Pryor</strong><a href="mailto:Joshua@BrazilianGoldCoffee.com">Joshua@BrazilianGoldCoffee.com</a></li><li><strong>Daniel Pryor</strong><a href="mailto:Daniel@BrazilianGoldCoffee.com">Daniel@BrazilianGoldCoffee.com</a></li><li><strong>General Information</strong><a href="mailto:info@BrazilianGoldCoffee.com">info@BrazilianGoldCoffee.com</a></li></ul>';
  }

  function addFarmerJump() {
    if (location.pathname !== '/' && location.pathname !== '') return;
    var links = document.querySelectorAll('#content_wrapper a, #content_wrapper button');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      if (el.closest && (el.closest('#header') || el.closest('.header') || el.closest('.footer'))) continue;
      var label = (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (label === 'OUR STORY' && !el.parentNode.querySelector('.bgc-farmer-jump')) {
        var a = document.createElement('a');
        a.className = 'bgc-farmer-jump';
        a.href = '/pages/copia-our-story#bgc-farmer-videos';
        a.textContent = 'FARMER VIDEOS';
        el.insertAdjacentElement('afterend', a);
        break;
      }
    }
  }

  function tuneStorySection() {
    if (location.pathname.indexOf('/pages/copia-our-story') === -1) return;
    setTimeout(function () {
      var block = document.querySelector('.bgc-story-videos');
      if (!block) return;
      block.id = 'bgc-farmer-videos';
      var eyebrow = block.querySelector('.bgc-story-videos__eyebrow');
      var h = block.querySelector('h3');
      var p = block.querySelector('p');
      if (eyebrow) eyebrow.textContent = 'MEET THE PEOPLE BEHIND THE COFFEE';
      if (h) h.textContent = 'GET TO KNOW OUR FARMERS';
      if (p) p.textContent = 'Meet some of the Brazilian specialty coffee farmers behind the coffees we love. Discover their farms, their families, and the people whose work begins every cup of Brazilian Gold Coffee.';
    }, 0);
  }

  function loadLeaflet(callback) {
    if (window.L) return callback();
    if (!document.getElementById('bgc-leaflet-css')) {
      var link = document.createElement('link');
      link.id = 'bgc-leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  function upgradeLocalMap() {
    if (location.pathname !== '/pages/localshops') return;
    var mapWrap = document.querySelector('.bgc-local__map');
    if (!mapWrap) return;
    var shops = [
      ['Empório Brasil','1636 New Salem Hwy B, Murfreesboro, TN 37128'],
      ['Dion’s South Salon','422 Main Street, Franklin, TN 37064'],
      ['Single Malt Cigar Bar','2018 Lindell Ave, Nashville, TN 37203'],
      ['Belle Meade Premium Cigars','104 46th Ave N, Nashville, TN 37209'],
      ['Rio Market','32-15 36th Avenue, Queens, NY 11106'],
      ['Plata Grocery','31-05 24th Ave, Queens, NY 11102'],
      ['Minas Emporium & Grill','2555 Delk Rd SE Suite B4, Marietta, GA 30067'],
      ['Main Street Market Antique Mall','215 West Main Street, Swainsboro, GA 30401']
    ];
    mapWrap.innerHTML = '<div id="bgc-all-shops-map" class="bgc-all-shops-map" aria-label="Map of Brazilian Gold Coffee local shops"></div><p class="bgc-map-note">Each marker corresponds to one of the partner shops listed on this page.</p>';
    loadLeaflet(function () {
      var map = L.map('bgc-all-shops-map', { scrollWheelZoom: false }).setView([36.2, -86.7], 5);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
      var bounds = [];
      var queue = Promise.resolve();
      shops.forEach(function (shop) {
        queue = queue.then(function () {
          var cacheKey = 'bgc-geocode-' + shop[1];
          var cached = null;
          try { cached = JSON.parse(localStorage.getItem(cacheKey) || 'null'); } catch (e) {}
          var p = cached ? Promise.resolve(cached) : fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(shop[1]))
            .then(function (r) { return r.json(); })
            .then(function (results) {
              if (!results || !results[0]) return null;
              var point = { lat: parseFloat(results[0].lat), lon: parseFloat(results[0].lon) };
              try { localStorage.setItem(cacheKey, JSON.stringify(point)); } catch (e) {}
              return point;
            });
          return p.then(function (point) {
            if (point) {
              L.marker([point.lat, point.lon]).addTo(map).bindPopup('<strong>' + shop[0] + '</strong><br>' + shop[1]);
              bounds.push([point.lat, point.lon]);
              if (bounds.length > 1) map.fitBounds(bounds, { padding: [28, 28] });
            }
            return new Promise(function (resolve) { setTimeout(resolve, cached ? 20 : 1000); });
          }).catch(function () { return new Promise(function (resolve) { setTimeout(resolve, 250); }); });
        });
      });
    });
  }

  function money(cents) {
    cents = Number(cents || 0);
    return '$' + (cents / 100).toFixed(2);
  }

  function imageFromProduct(product, fallback) {
    var image = product && product.featured_image;
    if (image && typeof image === 'string') return image.indexOf('//') === 0 ? 'https:' + image : image;
    if (image && image.src) return image.src.indexOf('//') === 0 ? 'https:' + image.src : image.src;
    if (product && product.images && product.images[0]) {
      var src = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      return src && src.indexOf('//') === 0 ? 'https:' + src : src;
    }
    return fallback;
  }

  function addSubscription(variantId, planId, statusEl) {
    if (statusEl) statusEl.textContent = 'Adding your subscription…';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, selling_plan: Number(planId) }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add subscription'); });
      return r.json();
    }).then(function () {
      if (statusEl) statusEl.textContent = 'Added — opening your cart.';
      window.location.hash = 'cart';
      window.location.reload();
    }).catch(function (err) {
      if (statusEl) statusEl.textContent = err.message || 'Could not add subscription. Please try again.';
    });
  }

  function buildSubscriptionCard(config, product) {
    var card = document.createElement('article');
    card.className = 'bgc-sub-card';
    var img = imageFromProduct(product, config.fallback);
    var variants = (product.variants || []).filter(function (v) { return v.available !== false; });
    var minPrice = variants.length ? Math.min.apply(null, variants.map(function (v) { return Number(v.price || 0); })) : Number(product.price || 0);
    card.innerHTML = '<div class="bgc-sub-card__image"><img src="' + img + '" alt="' + config.title + ' coffee bag" loading="lazy"></div><div class="bgc-sub-card__copy"><h2>' + config.title + '</h2><div class="bgc-sub-card__price">From ' + money(minPrice) + '</div><label class="bgc-sub-card__label">DELIVERY FREQUENCY</label><select class="bgc-sub-frequency" aria-label="Delivery frequency"></select><div class="bgc-sub-variants"></div><div class="bgc-sub-status" role="status" aria-live="polite"></div></div>';
    var select = card.querySelector('.bgc-sub-frequency');
    BGC.plans.forEach(function (plan) {
      var option = document.createElement('option');
      option.value = plan.id;
      option.textContent = plan.name;
      if (plan.id === BGC.monthlyPlan) option.selected = true;
      select.appendChild(option);
    });
    var wrap = card.querySelector('.bgc-sub-variants');
    var status = card.querySelector('.bgc-sub-status');
    variants.forEach(function (variant) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bgc-sub-variant';
      button.innerHTML = (variant.title || 'Coffee') + '<span>SUBSCRIBE &amp; SAVE • ' + money(variant.price) + ' before subscription savings</span>';
      button.addEventListener('click', function () { addSubscription(variant.id, select.value, status); });
      wrap.appendChild(button);
    });
    return card;
  }

  function upgradeSubscriptionPage() {
    if (location.pathname !== '/pages/coffee-subscription') return;
    var main = document.querySelector('.main_content_area') || document.querySelector('.section.content') || document.querySelector('#content_wrapper');
    var content = document.querySelector('.section.content .container') || document.querySelector('.main_content_area + .section.content .container') || document.querySelector('.page');
    if (!content) return;
    var hostSection = content.closest('.section.content') || content.closest('.main_content_area') || content.parentNode;
    var shell = document.createElement('section');
    shell.className = 'bgc-subscription-shell';
    shell.innerHTML = '<div class="bgc-subscription-inner"><div class="bgc-subscription-intro"><span class="bgc-subscription-kicker">NEVER RUN OUT OF GREAT COFFEE</span><h1>COFFEE SUBSCRIPTIONS</h1><p>Choose your Brazilian Gold Coffee, select your delivery rhythm, and use Subscribe &amp; Save for recurring delivery. Your actual Shopify subscription plan is added to the cart — this is not a one-time-purchase shortcut.</p></div><div class="bgc-subscription-grid"></div></div>';
    if (hostSection && hostSection.parentNode) hostSection.parentNode.insertBefore(shell, hostSection);
    if (main && main !== hostSection && main.parentNode) main.style.display = 'none';
    if (hostSection) hostSection.style.display = 'none';
    var grid = shell.querySelector('.bgc-subscription-grid');
    BGC.products.forEach(function (config) {
      fetch('/products/' + config.handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Product unavailable'); return r.json(); })
        .then(function (product) { grid.appendChild(buildSubscriptionCard(config, product)); })
        .catch(function () {
          var fallbackProduct = { price: 1900, variants: [], featured_image: config.fallback };
          grid.appendChild(buildSubscriptionCard(config, fallbackProduct));
        });
    });
  }

  /* Retained only as rollback/reference. Cart subscription UI is now owned by
     bgc-commerce-modernization-2026.js and this legacy routine is no longer invoked. */
  function upgradeCartDrawer() {
    var cartRoot = document.querySelector('#cart');
    if (!cartRoot) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var rows = cartRoot.querySelectorAll('li .cart__item');
      cart.items.forEach(function (item, index) {
        if (BGC.products.map(function (p) { return p.id; }).indexOf(Number(item.product_id)) === -1) return;
        var anchor = rows[index];
        if (!anchor) return;
        var li = anchor.closest('li');
        if (!li || li.querySelector('.bgc-cart-sub-toggle')) return;
        var currentPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? Number(item.selling_plan_allocation.selling_plan.id) : null;
        var box = document.createElement('div');
        box.className = 'bgc-cart-sub-toggle';
        box.innerHTML = '<strong>Purchase option</strong><button type="button" data-plan="">One-Time Purchase</button><button type="button" data-plan="' + BGC.monthlyPlan + '">Subscribe &amp; Save</button>';
        var buttons = box.querySelectorAll('button');
        if (currentPlan) buttons[1].classList.add('is-active'); else buttons[0].classList.add('is-active');
        buttons.forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault(); event.stopPropagation();
            var nextPlan = button.getAttribute('data-plan');
            button.textContent = 'Updating…';
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, selling_plan: nextPlan ? Number(nextPlan) : null })
            }).then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return r.json(); })
              .then(function () { window.location.hash = 'cart'; window.location.reload(); })
              .catch(function () { button.textContent = nextPlan ? 'Subscribe & Save' : 'One-Time Purchase'; });
          });
        });
        li.appendChild(box);
      });
    }).catch(function () {});
  }

  ready(function () {
    injectGlobalStyles();
    dedupeContact();
    upgradeWholesale();
    addFarmerJump();
    tuneStorySection();
    upgradeLocalMap();
    upgradeSubscriptionPage();
    /* Legacy upgradeCartDrawer intentionally retired. */
  });
})();